import { useCallback, useMemo } from 'react';

import { useOfficeEditingCtx } from '@/app/(app)/settings/office/provider';
import { DayScheduleEditor, DaySlot } from '@/components/molecules/day-schedule-editor';
import { DayOfWeek, DAYS_OF_WEEK } from '@/consts/date-time';
import { groupBy } from '@/lib/group';

export function OfficeHours() {
  const {
    office: { office_hours },
    update,
  } = useOfficeEditingCtx();
  const grouped = useMemo(() => {
    const groupedByDay = groupBy(office_hours, 'day_of_week');
    return DAYS_OF_WEEK.map((day) => ({
      day_of_week: day,
      slots: (groupedByDay.get(day) || []).sort((a, b) => a.start_time.localeCompare(b.start_time)),
    }));
  }, [office_hours]);

  const updateDaySlots = useCallback(
    (day: DayOfWeek, slots: DaySlot[]) => {
      const newDays = office_hours.filter((d) => d.day_of_week !== day);
      const newSlots = slots.map((slot) => ({
        ...slot,
        day_of_week: day,
      }));
      update({ office_hours: [...newDays, ...newSlots] });
    },
    [office_hours, update]
  );

  return (
    <div className='flex w-full flex-col gap-4'>
      <h3 className='text-heading-md'>Office hours</h3>
      <div className='flex flex-col'>
        {grouped.map((day) => (
          <DayScheduleEditor
            key={day.day_of_week}
            schedule={day}
            update={(slots) => updateDaySlots(day.day_of_week, slots)}
          />
        ))}
      </div>
    </div>
  );
}
